import DownloadApps from '@/components/downloadApps'
import InstitutionalBuyerContact from '@/components/institutionalBuyerContact'
import LayoutWithNavigation from '@/components/layoutWithNavigation'
import PageHeader from '@/components/pageHeader'
import Picture from '@/components/picture'
import { appList, STRINGS } from '@/constants/institutionalBuyers'

export async function getStaticProps() {
  return {
    props: {
      title: STRINGS.PAGE_TITLE,
      description: STRINGS.PAGE_DESCRIPTION,
    },
  }
}

const InstitutionalBuyers = () => (
  <LayoutWithNavigation>
    <section className="px-6 my-4 max-w-7xl m-auto">
      <section className="flex md:flex-row flex-col">
        <section className="md:w-2/3">
          <PageHeader
            heading={STRINGS.PAGE_HEADING}
            subHeading={STRINGS.PAGE_SUBHEADING}
          />
          <div className="md:flex-1 pt-4">
            <p className="whitespace-pre-wrap mb-2.5 text-footer-grey text-base font-natosans-light">
              {STRINGS.DESCRIPTION}
            </p>
            <div className="py-2.5">
              <DownloadApps apps={appList} />
            </div>
          </div>
        </section>
        <div className="md:w-1/3 md:px-4 pb-2.5 pt-[30px]">
          <Picture
            image="/assets/images/institutional-buyers"
            imageAlt={STRINGS.PAGE_HEADING}
            pictureStyle="flex justify-center"
            imageStyle="w-[55%]"
            loading="eager"
            aria-hidden="true"
            role="presentation"
          />
        </div>
      </section>
      <InstitutionalBuyerContact />
    </section>
  </LayoutWithNavigation>
)

export default InstitutionalBuyers
